import { ContextEvent, ContextProvider, createContext } from '@lit/context';
// Bridge the deployment root path into the qbo4.ai context.
// AI components consume 'qbo4.ai/config' with { apiBase? }. @quandis/qbo4.configuration
// already publishes the deployment root as 'qbo-config' { baseHref }, which it resolves
// from the qbo4-BaseHref response header shortly after load, so subscribe to that rather
// than calling detectRoot() here: webpack inlines the import.meta.url that detectRoot()
// defaults to as a build-machine file path, so it returns '' in a bundle.
// Context keys compare by value, so createContext() rebuilds the same keys the publishing
// packages use without importing their bindings. That matters: those packages sit in an
// import cycle, and a top-level read of one of their bindings lands in the temporal dead
// zone once the production build scope-hoists that cycle.
// A <qbo-config api-base="..."> element closer in the tree still takes precedence.
const _aiConfigContext = createContext('qbo4.ai/config');
const _qboConfigContext = createContext('qbo-config');
const _aiConfigProvider = new ContextProvider(document.documentElement, {
    context: _aiConfigContext,
    initialValue: { apiBase: '/ai' }
});
// Dispatched from <head> rather than <html>: qbo4.configuration hosts the 'qbo-config'
// provider on document.documentElement, and a provider ignores requests targeting its own
// host. subscribe: true so apiBase follows baseHref when the header lands.
document.head.dispatchEvent(new ContextEvent(_qboConfigContext, document.head, config => _aiConfigProvider.setValue({ apiBase: `${config?.baseHref ?? ''}/ai` }), true));
export * from '@quandis/qbo4.configuration';
export * from '@quandis/qbo4.logging';
export * from '@quandis/qbo4.ui';
export * from '@quandis/qbo4.ui-bridge';
export * from '@quandis/qbo4.documents';
export * from '@quandis/qbo4.messages';
export * from '@quandis/qbo4.security';
export * from '@quandis/qbo4.infrastructure.ui';
export * from '@quandis/qbo4.ai';
//# sourceMappingURL=Program.js.map